
const form = document.getElementById('advancedValidation');

function triggerEvent(el, type, obj) {
	var eventObj = document.createEventObject ? document.createEventObject() : document.createEvent('Event');
	if (eventObj.initEvent) {
		eventObj.initEvent(type, true, true);
	}
	Object.assign(eventObj,obj);
	el.dispatchEvent(eventObj);
	return eventObj;
}
// VALIDATING ALL FIELDS FOR DEAFULT FORM
function bananaOrCherry(value, field, required) {
	if (!required && !value.length) {
		/* Returning 'delay' prevents an error or success message from appearing. */
		return 'delay';
	}
	return value.toLowerCase() === 'banana' || value.toLowerCase() === 'cherry';
}
ui.validator(form, {
	fields: {
		yourName: { minLength: 3, errorLocation: 'below' }
		// email1: { required: true, pattern: 'email' },
		// url: { pattern: 'url' },
		// tel: { pattern: 'tel', errorLocation: 'below' },
		// number: { required: true, pattern: 'number' },
		// passwordA: { required: true, minLength: 6 },
		// passwordB: { match: 'passwordA', required: true },
		// file: { required: true, extensions: ['jpg', 'jpeg', 'png', 'gif'] },
		// myRadioCollection: { required: true, collection: document.querySelector('.myRadioCollection').querySelectorAll('input[type=radio]') },
		// myCollection2: { required: 3, collection: document.querySelector('.myCollection2').querySelectorAll('input[type=checkbox]') },
		// feedback: { maxLength: 20, when: 'keyup' },
		// custom2: {
		// 	pattern: (value, field) => {
		// 		if (!value.length || (!value.match(/^A/) && value.length < 4)) {
		// 			triggerEvent(field, 'validation-error-index', { detail: 0 });
		// 			return false;
		// 		} else if (!value.match(/^A/)) {
		// 			triggerEvent(field, 'validation-error-index', { detail: 1 });
		// 			return false;
		// 		} else if (value.length < 4) {
		// 			triggerEvent(field, 'validation-error-index', { detail: 2 });
		// 			return false;
		// 		}
		// 		return true;
		// 	}
		// },
		// custom3: { required: true, pattern: bananaOrCherry },
		// custom4: { pattern: bananaOrCherry },
		// terms: { required: true, errorLocation: 'below' },
		// email2: {
		// 	pattern: (value, field) => {
		// 		let success = false;
		// 		/* If field is blank, show no validation message */
		// 		if (!value.length) {
		// 			success = 'delay';
		// 		} else if (ui.validator.email(value)) {
		// 			success = 'delay';
		// 			window.setTimeout(() => {
		// 				triggerEvent(field, 'validation-message', { detail: [false, 1] });
		// 			  }, 1000);
		// 		}
		// 		return success;
		// 	}
		// }
	} // end of fields
});

// VALIDATION USING CUSTOM METHOD FOR ONSUBMIT
ui.validator(document.getElementById('formNoJump'), {
	grandmaBirth: { pattern: 'number', required: true },
	momBirth: { pattern: 'number', required: true },
	onSubmit: (valid, form) => {
		if (valid && document.getElementById('grandmaBirth').value > document.getElementById('momBirth').value) {
			ui.alert(document.getElementById('ageWarning'));
			// $('#submitForm').attr('disabled', 'disabled').addClass('disabled');
			// $('#formAlert').hide();
			return false;
		} else {

		}
		
	} // end of onsubmit
	
});

//TODO: OPNLY FOR TESTING
//triggerEvent(document.getElementById('yourName'), 'validation-remove');

	// TODO: ONLY FOR TESTING PURPOSES, NOT FOR DEMO, SHOW VALIDATION MESSAGE AFTER DELAY
		// email1: {
		// 	pattern: (value, field) => {
		// 		// simulating delayed ajax callback
		// 		setTimeout(function () {
		// 			triggerEvent(field, 'validation-message', { detail: [false, 1] });
		// 		}, 200);
		// 	}
		// }
		// TODO: ONLY FOR TESTING PURPOSES, NOT FOR DEMO, REMOVE VALIDATION MESSAGE





// WEBPACK FOOTER //
// ./src/components/form/form.demo.js